module.exports = __webpack_public_path__ + "static/media/Logo_color_SKHU_SK_RGB.33bd10fb.jpg";